<pulse-base
  [baseConfig]="baseConfig"
  [navigationConfig]="navigationConfig"
  [headerConfig]="headerConfig"
  [navMenu]="navMenu()"></pulse-base>
